<template>
    <div class="row">
        <div class="form-group" :class="{'col-sm-2': consent, 'col-sm-4': !consent}">
            <div class="toggle-switch float-right">
                <input type="hidden" :name="name" value="0">
                <input type="checkbox" class="toggle-switch__checkbox" :id="id" :name="name" :checked="isChecked">
                <i class="toggle-switch__helper"></i>
            </div>
        </div>
        <div class="col-sm-8 field-label text-left">{{ label }}</div>
    </div>
</template>

<script>
    import formElementMixin from '@/components/mixins/FormElementMixin'

    export default {
        mixins: [formElementMixin],

        computed: {
            isChecked() {
                if(this.value+'' == '1' || this.value == true || this.value == 'on'){
                    return true;
                }

                return false;
            }
        }

    }
</script>

<style lang="scss" scoped>
    .toggle-switch{
        margin-top: 0.7rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/form_elements/Switch.vue